<div class="cb-modal">
    <div class="cb-modal__icon" aria-hidden="true">
        <svg width="56" height="56" viewBox="0 0 24 24" fill="none" stroke="#dc2626" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
            <rect x="3" y="11" width="18" height="11" rx="2" />
            <path d="M7 11V7a5 5 0 0 1 10 0v4" />
        </svg>
    </div>

    <h2 class="cb-modal__title">Acceso bloqueado por falta de pago</h2>

    <p class="cb-modal__body" *ngIf="!pendingVerification">
        Tu acceso a Fina ha sido bloqueado por falta de pago de tu préstamo solicitado. Para retomar acceso tienes que pagar lo que falta de tu cuota
        <strong>+ fee de reactivación ({{ money(data.activationFee) }})</strong>.
    </p>
    <p class="cb-modal__body" *ngIf="pendingVerification">Ya registraste el pago de tu cuota vencida. Tu acceso a Fina se reactiva cuando el equipo de Fina lo verifique.</p>

    <!-- ADM-799: soporte rechazó el último pago o abono de la cuota vencida (mismo aviso que la tarjeta). Motivo del admin, siempre con {{ }}. -->
    <div class="cb-modal__error cb-modal__error--rejected" *ngIf="rejectionNotice && !pendingVerification && !notifiedOk" data-test="cb-rejected">{{ rejectionNotice }}</div>

    <!-- Cada monto USD lleva debajo su equivalente en Bs. a la tasa BCV del día (línea oculta si la tasa no cargó). -->
    <div class="cb-modal__breakdown" *ngIf="!pendingVerification">
        <div class="cb-modal__row">
            <span
                >Saldo de la cuota vencida<span *ngIf="data.firstOverdueInstallmentNumber"> #{{ data.firstOverdueInstallmentNumber }}</span></span
            >
            <span class="cb-modal__row-amounts">
                <strong>{{ money(data.dueAmount) }}</strong>
                <span class="cb-modal__ves" *ngIf="vesRate$ | async as tasa">Bs. {{ data.dueAmount * tasa | number : '1.2-2' }}</span>
            </span>
        </div>
        <div class="cb-modal__row">
            <span>Fee de reactivación</span>
            <span class="cb-modal__row-amounts">
                <strong>{{ money(data.activationFee) }}</strong>
                <span class="cb-modal__ves" *ngIf="vesRate$ | async as tasa">Bs. {{ data.activationFee * tasa | number : '1.2-2' }}</span>
            </span>
        </div>
        <div class="cb-modal__row cb-modal__row--total">
            <span>Total a pagar</span>
            <span class="cb-modal__row-amounts">
                <strong>{{ money(data.totalToUnblock) }}</strong>
                <!-- ADM-678 (8ª iteración): en local/staging (`testData.enabled`) el equivalente
                     en Bs. del total es EDITABLE. Precargado con total × tasa del día; solo si
                     el tester lo edita viaja como `testAmountVes`. En producción, label. -->
                <ng-container *ngIf="vesRate$ | async as tasa">
                    <span class="cb-modal__ves" *ngIf="!testData.enabled">Bs. {{ data.totalToUnblock * tasa | number : '1.2-2' }}</span>
                    <span class="cb-modal__ves cb-modal__ves--editable" *ngIf="testData.enabled">
                        <span>Bs.</span>
                        <input
                            class="cb-modal__ves-input"
                            type="text"
                            inputmode="numeric"
                            autocomplete="off"
                            aria-label="Monto en bolívares a consultar al banco"
                            [class.cb-modal__ves-input--invalid]="testAmountVesInvalid"
                            [ngModel]="testAmountVes"
                            [ngModelOptions]="{ standalone: true }"
                            (input)="onTestAmountInput($event)"
                            [disabled]="submitting || uploadingComprobante"
                        />
                        <span class="cb-modal__staging-tag">editable</span>
                        <button *ngIf="testAmountDirty" type="button" class="cb-modal__ves-reset" (click)="resetTestAmount()">Restablecer</button>
                    </span>
                </ng-container>
            </span>
        </div>
        <small *ngIf="testData.enabled && testAmountVesInvalid" class="cb-modal__field-error cb-modal__ves-error">Escribe un monto en bolívares mayor que 0.</small>
    </div>

    <!--
        Datos de pago de Fina (mismas filas que el `pay-modal`, fuente única en
        `constants/fina-payment-info.ts`). Cada fila tiene un botón de copiar al portapapeles.
    -->
    <!-- ADM-678 (2ª iteración): aviso de datos de prueba. Solo en staging/local. -->
    <fina-staging-data-warning *ngIf="testData.enabled && !pendingVerification" [detail]="stagingWarningDetail"></fina-staging-data-warning>

    <!-- A un teléfono se le envía un pago móvil, no se le transfiere. -->
    <div class="cb-modal__pay-card-label" *ngIf="!pendingVerification">{{ isPagoMovil ? 'Envía el pago móvil a estos datos:' : 'Transfiere a estos datos:' }}</div>
    <div class="cb-modal__pay-card" *ngIf="!pendingVerification">
        <div *ngFor="let row of displayedPaymentData; let last = last" class="cb-modal__pay-row" [class.cb-modal__pay-row--last]="last">
            <div>
                <div class="cb-modal__pay-row-label">{{ row.label }}</div>
                <div class="cb-modal__pay-row-value">{{ row.value }}</div>
            </div>
            <!-- `copyValue` cuando lo copiado difiere de lo mostrado: el teléfono se ve
                 con guion pero se copia en dígitos corridos. -->
            <button type="button" class="cb-modal__pay-copy-btn" (click)="copy(row.key, row.copyValue || row.value)" [attr.aria-label]="'Copiar ' + row.label">
                <svg *ngIf="copiedKey === row.key" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#00AC69" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round">
                    <path d="m5 13 4 4L19 7" />
                </svg>
                <svg *ngIf="copiedKey !== row.key" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#9DA6BA" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                    <rect x="9" y="9" width="11" height="11" rx="2" />
                    <path d="M5 15V5a2 2 0 0 1 2-2h10" />
                </svg>
            </button>
        </div>
    </div>

    <!--
        Política v2: el cliente notifica su pago acá mismo. Pasa al flujo normal de
        verificación (cuota → verifying); el bloqueo se mantiene hasta que el equipo
        de gestión confirme el pago.
        FINA-2062: viewerMode (non-owner) — solo lectura, sin formulario de pago.
        El backend rechaza con 403 si non-owner intenta PUT /api/creditos/:id/pay.
    -->
    <ng-container *ngIf="!notifiedOk && !viewerMode && !pendingVerification">
        <!-- Comprobante opcional (FINA-3378; mismo patrón que `pay-modal`) -->

        <div class="cb-modal__comprobante">
            <div class="cb-modal__comprobante-label">Foto del comprobante <span class="cb-modal__comprobante-optional">(opcional)</span></div>
            <label class="cb-modal__comprobante-upload" [class.cb-modal__comprobante-upload--has-file]="comprobantePreview">
                <img *ngIf="comprobantePreview" [src]="comprobantePreview" class="cb-modal__comprobante-preview" alt="Comprobante" />
                <ng-container *ngIf="!comprobantePreview">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#9DA6BA" stroke-width="1.6" stroke-linecap="round">
                        <rect x="3" y="3" width="18" height="18" rx="3" />
                        <circle cx="8.5" cy="8.5" r="1.5" />
                        <path d="m21 15-5-5L5 21" />
                    </svg>
                    <span>Toca para agregar imagen</span>
                </ng-container>
                <input type="file" accept="image/*" hidden (change)="onFileSelected($event)" />
            </label>
            <button *ngIf="comprobantePreview" type="button" class="cb-modal__comprobante-remove" (click)="removeComprobante()">Quitar imagen</button>
            <small *ngIf="comprobanteError" class="cb-modal__field-error">{{ comprobanteError }}</small>
        </div>

        <!-- ══════════════════════════════════════════════════════════════════
             ADM-678: banco, teléfono y fecha del pago. Son OBLIGATORIOS para el
             endpoint de pago desde que la verificación es automática — sin ellos
             responde 400 y el cliente bloqueado no puede desbloquearse.
             ══════════════════════════════════════════════════════════════════ -->
        <!-- ADM-678 (7ª iteración): el selector de "movimiento de prueba" se retiró
             (sesgaba las pruebas: prellenaba datos y el API sustituía el monto).
             Staging se comporta como producción; solo la cuenta receptora sigue
             siendo la de QA. -->

        <!--
            ADM-678: los tres campos de la verificación van en un grid de 2 columnas
            (banco + teléfono arriba, fecha abajo) en lugar de apilados. Apilados,
            sumados a la referencia y al comprobante, dejaban el botón de enviar
            fuera del viewport en pantallas bajas — y este modal es la única vía que
            tiene un cliente bloqueado por mora para desbloquearse.
        -->
        <!--
            ADM-678 (4ª iteración): toggle compacto de método. No van las cards
            grandes del `pay-modal`: este modal es más chico y el objetivo acá es
            que un cliente bloqueado pueda reportar una transferencia, no lucirlo.
        -->
        <div class="cb-modal__method">
            <button type="button" class="cb-modal__method-btn" [class.cb-modal__method-btn--active]="isPagoMovil" (click)="selectMethod('pago_movil')" [disabled]="submitting || uploadingComprobante">
                Pago móvil
            </button>
            <button
                type="button"
                class="cb-modal__method-btn"
                [class.cb-modal__method-btn--active]="!isPagoMovil"
                (click)="selectMethod('transferencia')"
                [disabled]="submitting || uploadingComprobante"
            >
                Transferencia
            </button>
        </div>

        <div class="cb-modal__form-grid">
            <div class="cb-modal__field">
                <label class="cb-modal__ref-label" for="cb-bank">Banco desde el que pagaste</label>
                <fina-bank-select
                    inputId="cb-bank"
                    accent="purple"
                    [banks]="banks"
                    [(ngModel)]="bankCode"
                    (ngModelChange)="onBankChanged()"
                    [disabled]="submitting || uploadingComprobante"
                ></fina-bank-select>
            </div>

            <div class="cb-modal__field">
                <label class="cb-modal__ref-label" for="cb-phone">Teléfono del pago móvil</label>
                <div class="cb-modal__phone-group">
                    <select
                        id="cb-phone-prefix"
                        class="cb-modal__select cb-modal__select--prefix"
                        aria-label="Prefijo del teléfono"
                        [(ngModel)]="phonePrefix"
                        [disabled]="submitting || uploadingComprobante"
                    >
                        <option *ngFor="let p of phonePrefixes" [value]="p">{{ p }}</option>
                    </select>
                    <input
                        id="cb-phone"
                        type="text"
                        class="cb-modal__ref-input"
                        #cbPhoneInput="ngModel"
                        [(ngModel)]="phoneNumber"
                        (input)="onPhoneInput($event)"
                        inputmode="numeric"
                        pattern="\d{7}"
                        placeholder="1234567"
                        [disabled]="submitting || uploadingComprobante"
                        autocomplete="off"
                        required
                    />
                </div>
                <!-- QA ciclo 1 (CN-11): mismos mensajes inline que el pay-modal. -->
                <small *ngIf="!(cbPhoneInput.touched && cbPhoneInput.invalid)" class="cb-modal__field-hint">Debe ser el número desde el que salió el pago.</small>
                <small *ngIf="cbPhoneInput.touched && cbPhoneInput.invalid" class="cb-modal__field-error">El teléfono debe tener 7 dígitos después del prefijo.</small>
            </div>

            <!-- ADM-678 (7ª iteración): `ngbDatepicker` con el calendario de Fina (ver
                 pay-modal). Modelo = 'YYYY-MM-DD' del API; el cliente ve dd/mm/aaaa.
                 Ícono SVG inline porque este módulo (shared, eager) no importa IconsModule. -->
            <div class="cb-modal__field">
                <label class="cb-modal__ref-label" for="cb-date">Fecha del pago</label>
                <div class="cb-modal__date-group">
                    <input
                        id="cb-date"
                        class="cb-modal__ref-input cb-modal__date-input"
                        name="paymentDate"
                        #cbDateInput="ngModel"
                        #cbDatepicker="ngbDatepicker"
                        ngbDatepicker
                        [(ngModel)]="paymentDate"
                        [maxDate]="todayStruct"
                        [minDate]="depositDayStruct"
                        container="body"
                        datepickerClass="creditos-datepicker"
                        [autoClose]="'outside'"
                        placement="top-start top-end bottom-start bottom-end"
                        outsideDays="hidden"
                        placeholder="dd/mm/aaaa"
                        inputmode="numeric"
                        autocomplete="off"
                        [disabled]="submitting || uploadingComprobante"
                        required
                    />
                    <button type="button" class="cb-modal__date-btn" aria-label="Elegir fecha en el calendario" (click)="cbDatepicker.toggle()" [disabled]="submitting || uploadingComprobante">
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                            <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                            <line x1="16" y1="2" x2="16" y2="6"></line>
                            <line x1="8" y1="2" x2="8" y2="6"></line>
                            <line x1="3" y1="10" x2="21" y2="10"></line>
                        </svg>
                    </button>
                </div>
                <small *ngIf="isDateBeforeDeposit" class="cb-modal__field-error">La fecha no puede ser anterior al desembolso de tu préstamo ({{ depositDayLabel }}).</small>
                <small *ngIf="cbDateInput.touched && cbDateInput.invalid && !isDateBeforeDeposit" class="cb-modal__field-error"
                    >Indica la fecha en la que hiciste el pago (dd/mm/aaaa, no futura).</small
                >
            </div>
        </div>

        <label class="cb-modal__ref-label" for="cb-ref-input"> Número de referencia del pago </label>
        <!-- Sin `maxlength` (QA ciclo 1, CB-02): el handler filtra los no dígitos y deja los
             últimos 6 (o, Banesco→Banesco, la referencia completa sin recortar); el atributo
             truncaba antes y perdía el último al pegar. -->
        <input
            id="cb-ref-input"
            type="text"
            class="cb-modal__ref-input"
            #cbRefInput="ngModel"
            [(ngModel)]="referenceNumber"
            (input)="onReferenceInput($event)"
            inputmode="numeric"
            [pattern]="referencePattern"
            [disabled]="submitting || uploadingComprobante"
            [placeholder]="referencePlaceholder"
            required
            autocomplete="off"
        />
        <small class="cb-modal__field-hint" [class.cb-modal__field-error]="cbRefInput.touched && cbRefInput.invalid" data-test="reference-digits">{{ referenceError }}</small>

        <div *ngIf="errorMsg" class="cb-modal__error">{{ errorMsg }}</div>

        <button type="button" class="cb-modal__cta" [disabled]="!canSubmit" (click)="notifyPayment()">
            {{ uploadingComprobante ? 'Subiendo imagen…' : submitting ? 'Enviando...' : 'Notificar pago' }}
        </button>
    </ng-container>

    <!-- Modo VIEWER (non-owner): leyenda, sin formulario de pago -->
    <div *ngIf="viewerMode && !notifiedOk" class="cb-modal__viewer-notice">
        <div class="cb-modal__viewer-notice-text">
            Solo el dueño de la cuenta puede pagar la cuota.<br />
            Contacta al dueño para que regularice el préstamo.
        </div>
    </div>

    <!-- Abonos: la cuota vencida ya está cubierta (desde el dashboard) y espera verificación -->
    <div *ngIf="pendingVerification && !notifiedOk" class="cb-modal__notified">
        <div class="cb-modal__notified-icon" aria-hidden="true">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#16a34a" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M5 13l4 4L19 7" />
            </svg>
        </div>
        <div class="cb-modal__notified-title">Pago en verificación</div>
        <div class="cb-modal__notified-body">El equipo de Fina está verificando tu pago. Tu acceso a la plataforma se restaura cuando quede confirmado.</div>
    </div>

    <!-- Estado post-notificación: la cuota está en verificación; admin debe confirmar -->
    <div *ngIf="notifiedOk" class="cb-modal__notified">
        <div class="cb-modal__notified-icon" aria-hidden="true">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#16a34a" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M5 13l4 4L19 7" />
            </svg>
        </div>
        <!-- ADM-678 × ADM-691: el copy sale del resultado del banco (verificado, en revisión). -->
        <div class="cb-modal__notified-title">{{ resultTitle || 'Pago notificado' }}</div>
        <div class="cb-modal__notified-body" *ngIf="resultMessage">{{ resultMessage }}</div>
        <div class="cb-modal__notified-body" *ngIf="!resultMessage">
            Recibimos la referencia <strong>{{ referenceNumber }}</strong
            >. El equipo de Fina la verificará en minutos. Tu acceso a la plataforma se restaura cuando el pago quede confirmado.
        </div>
    </div>
</div>
